import axios from '../utils/axios';

export default function getSeekerAnalysis (adminId, seekerId) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/ttl-follow`, { params: {seekerId} })
        .then(response => {
            // Map the new response structure to match the old structure
            if (response.data && response.data.data && response.data.data.data ) {
                return {
                    data: {
                        data : {
                            data: {
                                ttl_follow: response.data.data.data.data.totalFollowUp,
                                u_follow: response.data.data.data.data.unFollowUp
                            }
                        }
                    }
                };
            }
            return response;
        })
        .catch(err => {
            return err;
        });
};